import script from "./TooltipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipModal.vue?vue&type=script&setup=true&lang=js"

import "./TooltipModal.vue?vue&type=style&index=0&id=7640ff02&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7640ff02"]])

export default __exports__